const PREFIX = '@socialcam/';

export const StorageKeys = {
  SELECTED_PRODUCTION: `${PREFIX}selected_option_production`,
  THEME: `${PREFIX}theme`,
  MODO_MODERACAO: `${PREFIX}modoModeracao`,
  FILTRO: `${PREFIX}filtro`,
  FILTROS: `${PREFIX}filtros`,
  CONFIG_MOSAICO: `${PREFIX}config_mosaico`,
  TELA_DESCANSO_ATIVA: `${PREFIX}tela_descanso_ativa`,
  USAR_TELA_DESCANSO: `${PREFIX}usar_tela_descanso`,
  COD_PORTAL: `${PREFIX}cod_portal`,
};

export function getItem(key) {
  try {
    const raw = localStorage.getItem(key);
    if (raw === null) return null;
    return JSON.parse(raw);
  } catch {
    return localStorage.getItem(key);
  }
}

export function setItem(key, value) {
  localStorage.setItem(key, typeof value === 'object' ? JSON.stringify(value) : String(value));
}

export function removeItem(key) {
  localStorage.removeItem(key);
}
